import { CommsChatProvider, CommsFilterProvider, CommunicationsProvider } from '../../../../../hooks/use-communications';
import { InboxPatientProfile } from './inbox';

export const Inbox = () => {
  return (
    <CommsFilterProvider>
      <CommunicationsProvider>
        <CommsChatProvider>
          <InboxPatientProfile allowReadOnly />
        </CommsChatProvider>
      </CommunicationsProvider>
    </CommsFilterProvider>
  );
};
